import { GetServerSideProps } from 'next';

import {
  getCalculatorJson,
  isCalculatorPage,
} from '../../../../components/Calculators/calculator-revamp/utils';
import { FaqVariants } from '../../../../components/Common/FAQS';
import { ISTATIC_PAGE_PROPS } from '../../../../components/cms/layout/types';
import {
  decodeHtml,
  generateComponent,
} from '../../../../components/cms/layout/util';
import CMSPageDataServices from '../../../../components/cms/services/cms-pages.service';
import {
  CorporatePage,
  DefaultMeta,
} from '../../../../types/partner-page-types';
import { render404Page } from '../../../../utils/UtilFunctions';
import { processHtml } from '../../../../utils/static-pages/staticPages';

export interface PartnerPagesProps {
  postData: CorporatePage;
  metaData: DefaultMeta;
}

const PartnerPage: React.FC<ISTATIC_PAGE_PROPS> = ({
  postData,
  metaData,
  pageType,
}): JSX.Element => {
  return <>{generateComponent({ postData, pageType, metaData })}</>;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params, query } = context;

  if (!query.domain || !query.language) return render404Page();
  try {
    const pageData = await CMSPageDataServices.getPageByURL(
      params?.static as string,
      parseInt(query.domain as string),
      parseInt(query.language as string),
      decodeHtml(query.content_type as string) || 'cms'
    );

    if (pageData.status === 200) {
      const processedData = await pageData.data;
      const isCalc = isCalculatorPage(processedData.category);
      processedData.isCalculator = isCalc;
      const calcJson = await getCalculatorJson(processedData.content);
      processedData.calculatorData = isCalc ? calcJson?.data : {};

      const newHtmlData = await processHtml(processedData?.content);
      processedData.content = newHtmlData;

      return {
        props: {
          postData: {
            data: processedData || {},
          },
          metaData: {},
          pageType: isCalc ? FaqVariants.calculator : 'CMS',
        },
      };
    }
    return render404Page();
  } catch (error: unknown) {
    console.log(
      'Error from clear-frontier/preview/s',
      error instanceof Error ? error.message : 'Unknown error'
    );
    return render404Page();
  }
};

export default PartnerPage;
